import ApiRequest from "./ApiRequest";

interface IParamType {
}

class AxiosFindPegawai extends ApiRequest<IParamType> {
    constructor() {
        super("/find_pegawai");
    }

    get(token: string, id: string) {
        this.path += `?id=${id}`
        return this.get_request(token);
    }
}

export default AxiosFindPegawai;
